import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuFR from "../../components/fr/MenuFR";
import FooterFR from "../../components/fr/FooterFR";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Conseil, défense et litiges — Avocats à Malines"}
                    description={"Droit administratif, de la fonction publique, des affaires, fiscalité, droit civil et pénal — nous conseillons et défendons les particuliers et les entreprises"}
                    url={"https://www.coeladvocaten.be/fr/conseils-defense-litiges"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/advies-verdediging-geschillen", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/conseils-defense-litiges", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/advice-defense-disputes", language:"en" }
                    ]}
                />

                <MenuFR
                    switchUrlNL="/nl/advies-verdediging-geschillen"
                    switchUrlEN="/en/advice-defense-disputes"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-conseils-defense-litiges"></div>
                        <div className="slider">
                            <h1>Nos services</h1>
                            <h2>Conseils, défense et litiges</h2>
                            <p></p>
                            <a href="/fr/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Nos avocats vous apportent leur expertise pour vous conseiller et défendre vos intérêts dans les domaines suivants.</p>
                                            <p>Droit administratif et droit de la fonction publique</p>
                                            <p><b>Défense des particuliers et des entreprises contre les décisions des autorités administratives, à quelque niveau que ce soit, depuis la procédure arbitrale de révision jusqu’à l’annulation de décisions par le Conseil d’État</b></p>
                                            <p>-	Litiges avec les administrations: refus ou révocation d’autorisations ou de licences, refus de mariage ou d’entrée sur le territoire, etc. </p>
                                            <p>-	Litiges concernant les procédures de nomination et de licenciement pour le personnel statutaire et le personnel contractuel</p>
                                            <p><b>Droit des sociétés</b></p>
                                            <p>Conseils et défense dans toutes les matières relevant de la vie des entreprises: </p>
                                            <p>-	Startups et création d’entreprises: études de faisabilité et prévisions, choix de la forme de l’entreprise, élaboration d’un plan financier, inscription à la caisse d’assurances sociales, enregistrement BCE (Banque Carrefour des entreprises), activation du numéro de TVA, optimisation des cotisations sociales et des revenus, etc.</p>
                                            <p>-	Litiges entre associés</p>
                                            <p>-	Fusions et acquisitions</p>
                                            <p>-	Réorganisations, liquidations et faillites</p>
                                            <p><b>Droit fiscal</b></p>
                                            <p>Conseil et défense des particuliers et des entreprises</p>
                                            <p>-	Fiscalité des personnes et des entreprises: impôt des personnes physiques, impôt des sociétés, impôt des personnes morales, fiscalité des non-résidents, TVA, etc.</p>
                                            <p>-	Droits d’enregistrement et hypothèques</p>
                                            <p>-	Droits de succession et planification successorale nationale et internationale</p>
                                            <p>-	Taxes régionales et locales</p>
                                            <p>-	Droit fiscal européen et international</p>
                                            <p>-	Procédure fiscale</p>
                                            <p>-	Demandes de décisions anticipées, au niveau régional flamand et au niveau fédéral</p>
                                            <p>-	Sociétés de gestion et sociétés patrimoniales</p>
                                            <p>-	Fiscalité transfrontalière et conventions préventives de la double imposition</p>
                                            <p>-	Achats de résidences secondaires à l’étranger (y compris l’Espagne)</p>
                                            <p><b>Droit civil</b></p>
                                            <p>Conseil et défense des particuliers et des entreprises, particulièrement en matière de baux commerciaux et de droit agricole:</p>
                                            <p>-	Servitudes</p>
                                            <p>-	Baux fonciers et baux à ferme</p>
                                            <p>-	Loyers et loyers commerciaux</p>
                                            <p>-	Expropriations</p>
                                            <p><b>Droit pénal</b></p>
                                            <p>Défense des particuliers et des entreprises pour toutes les affaires au pénal: tribunal de police, tribunal de première instance et jusqu’à la Cour de cassation, comme partie défenderesse et partie civile.</p>
                                            <p>CTA : Besoin d’un conseil ou de défense ?</p>
                                            <p><br /></p>
                                            <p className="text-center"><a href="/fr/contact" alt="contact" className="button">info@coeladvocaten.be</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /><br /></div>
                        </div>
                    </div>
                </div>

                <FooterFR />
            </Layout>
        );
    }
}

export default Index;
